import {firestore} from '../firebaseConfig';
// var dietsFirestoreRef = firestore.collection("/diets");
const DataApi = {
    cuisine: firestore.collection("/cuisines"),
    tools: firestore.collection("/tools"),
    drafts: firestore.collection("/drafts")
    

}
export default DataApi